// Global Setting
import '../styles/app.scss'

// App Setting
import $ from 'jquery'
import Header from './modules/header'
import Screen from './modules/screen'
import AnchorLink from './modules/anchorlink'
import Top from './modules/top'
import Cases from './modules/case'
import ContactForm from './modules/contact'
import TabletViewport from './modules/tabletViewport'

const header = new Header()
header.init()
Top()
const cases = new Cases()
cases.init()
const screen = new Screen()
$(window).on('resize', screen.size())
$(window).on('breakpointChange')

const anchorlink = new AnchorLink({
  target: '.js-anchorlink'
})

anchorlink.init()
// anchorlink.anotherPage()

const appHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight()

ContactForm()
TabletViewport()
